const SectionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
    </svg>
);

const ServicesPage = ({ attributes }) => {
    const { services = {}, primaryColor = '#ff0037' } = attributes;
    const title = services.title || 'Our Services';
    const subtitle = services.subtitle || '';
    const intro = services.intro || '';
    const groups = Array.isArray(services.groups) ? services.groups : [];

    return (
        <div className="gmf-page-wrapper">
            <section className="gmf-page-hero">
                <div className="gmf-page-hero-inner">
                    {subtitle ? <p className="gmf-page-eyebrow gmf-accent-color">{subtitle}</p> : null}
                    <h1 className="gmf-page-title">{title}</h1>
                    <div className="gmf-divider gmf-divider--center" />
                    {intro ? <p className="gmf-page-subtitle">{intro}</p> : null}
                </div>
            </section>

            <section className="gmf-privacy-sections" style={{ maxWidth: 900, margin: '0 auto 48px', padding: '0 20px' }}>
                {groups.map((group, index) => {
                    const items = Array.isArray(group.items) ? group.items : [];
                    return (
                        <div key={index} className="gmf-privacy-section-card">
                            <div className="gmf-privacy-section-header">
                                <div className="gmf-privacy-section-icon" style={{ color: primaryColor }}>
                                    <SectionIcon />
                                </div>
                                <h2 className="gmf-privacy-section-title">{group.title}</h2>
                            </div>
                            <div className="gmf-privacy-section-content">
                                {items.length > 0 ? (
                                    <ul className="gmf-profile-edu-list">
                                        {items.map((line, i) => (
                                            <li key={i} className="gmf-profile-edu-item">
                                                <span className="gmf-dot" />
                                                <span>{line}</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>{group.body || ''}</p>
                                )}
                            </div>
                        </div>
                    );
                })}
            </section>
        </div>
    );
};

export default ServicesPage;
